module.exports = "<div class=\"container-fluid no-padding\">\n\n    <div class=\"panel panel-default m-b-0\">\n        <div class=\"panel-body\">\n\n        </div>\n    </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/donna-core/src/app/locations/pages/show/show.page.html
// module id = ./libs/donna-core/src/app/locations/pages/show/show.page.html
// module chunks = main